import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../utility/Utility";
import RoleModel from "../RoleModel/RoleModel";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

export default function UpdateRole() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
 
  const [showUserModal, setShowUserModal] = useState(false);
  const [formData, setFormData] = useState({
    userType: "",
    role_name: "",
    userId: "",
    permissionName: "",
    actions: [],
    selectedRole: "",

    admindashboard: false,
    userManagement: false,
    managedeletionrequest: false,
    roleManagement: false,
    homeinquiry: false,
    admininquirylist: false,
    adminleads: false,
    admincategory: false,
    adminsubcategory: false,
    adminemployeemanagement: false,
    adminheroslider: false,
    admintestimonials: false,
    adminpartners: false,
    admincompany: false,
    admincommissionmanagement: false,
    adminpolicymanagement: false,
    adminfeedback: false,
    adminhelpandsupport: false,
    settings: false
  });

  const permissionDisplayNames = {
    admindashboard: "Dashboard",
    userManagement: "User Management",
    managedeletionrequest: "Manage Deletion Request",
    roleManagement: "Role Management",
    homeinquiry: "Home Inquiry",
    admininquirylist: "Admin Inquiry List",
    adminleads: "Admin Leads",
    admincategory: "Admin Category",
    adminsubcategory: "Admin Subcategory",
    adminemployeemanagement: "Admin Employee Management",
    adminheroslider: "Admin Hero Slider",
    admintestimonials: "Admin Testimonials",
    adminpartners: "Admin Partners",
    admincompany: "Admin Company",
    admincommissionmanagement: "Admin Commission Management",
    adminpolicymanagement: "Admin Policy Management",
    adminfeedback: "Admin Feedback",
    adminhelpandsupport: "Admin Help and Support",
    settings: "Settings",
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (state) {
      const mappedActions = state.permission.map(perm => ({
        permission: perm.permissionName,
        actions: perm.actions
      }));

      setFormData({
        actions: mappedActions,
        userType: state.userId?.role,
        role_name: state.userId?.fullName,
        userId: state.userId?._id,
        selectedUser: state.userId,
        permissions: state.permission
      });
    }
  }, [state]);

  const handleUserSelect = () => {
    setShowUserModal(true);
  }

  const updateActions = (permission, action) => {
    const existingActions = formData.actions?.find(a => a.permission === permission) || null;
    if (existingActions) {
      if (existingActions.actions.includes(action)) {
        setFormData({ ...formData, actions: formData.actions.map(a => a.permission === permission ? { ...a, actions: a.actions.filter(ac => ac !== action) } : a) });
      } else {
        setFormData({ ...formData, actions: formData.actions.map(a => a.permission === permission ? { ...a, actions: [...a.actions, action] } : a) });
      }
    } else {
      setFormData({ ...formData, actions: [...formData.actions, { permission, actions: [action] }] });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Format permissions array according to API structure
      const permissions = formData.actions
        .filter(action => action.actions.length > 0)
        .map(action => ({
          permissionName: action.permission,
          actions: action.actions
        }));

      const response = await postData("api/permissions", {
        userId: formData.userId,
        permission: permissions
      });

      if (response?.success) {
        toast.success("Permissions updated successfully");
        navigate("/role-list")
      } else {
        toast.error(response.data.message || "Failed to update permissions");
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message || "Error updating permissions");
      } else if (error.request) {
        toast.error("Network error. Please try again.");
      } else {
        toast.error("An error occurred. Please try again.");
      }
      console.error("Add role error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <CustomLoader loading={loading} />
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1 mb-2 mb-sm-0">
              <h4 className="fs-18 fw-semibold m-0">Add Role</h4>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title mb-0">Role Details</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-md-12 mb-3">
                        <div className="d-flex flex-column flex-md-row align-items-md-center">
                          <label htmlFor="selectedRole" className="form-label mb-2 mb-md-0 me-md-3">
                            Select Role*
                          </label>
                          <button 
                            type="button" 
                            className="btn btn-primary"
                            onClick={handleUserSelect}
                            style={{ minWidth: "120px" }}
                            disabled={formData.userId}
                          >
                            Select User
                          </button> 
                        </div>
                      </div>
                      
                      <div className="col-lg-6 col-md-12">
                        {formData.userId && formData.selectedUser && (
                          <div className="card mb-3 mb-lg-0">
                            <div className="card-header">
                              <h6 className="card-title mb-0">Selected User Details</h6>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div className="col-sm-6 col-12 mb-2"><strong>Name:</strong> {formData.selectedUser.fullName}</div>
                                <div className="col-sm-6 col-12 mb-2"><strong>Email:</strong> {formData.selectedUser.email}</div>
                                <div className="col-sm-6 col-12 mb-2"><strong>Role:</strong> {formData.selectedUser.role}</div>
                                <div className="col-sm-6 col-12 mb-2"><strong>Phone:</strong> {formData.selectedUser.mobile}</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-12">
                        <div className="card-header mb-3">
                          <h5 className="card-title mb-0">Permissions</h5>
                        </div>
                        
                        <div className="row">
                          {Object.keys(permissionDisplayNames).map(permission => (
                            <div key={permission} className="col-12 mb-4">
                              <div className="card permission-card">
                                <div className="card-header bg-light">
                                  <h6 className="mb-0">{permissionDisplayNames[permission]}</h6>
                                </div>
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-md-3 col-6 mb-2">
                                      <div className="form-check">
                                        <input 
                                          className="form-check-input" 
                                          type="checkbox" 
                                          id={`${permission}-read`} 
                                          checked={formData.actions.find(a => a.permission === permission)?.actions.includes('read')}
                                          onChange={() => updateActions(permission, 'read')} 
                                        />
                                        <label className="form-check-label" htmlFor={`${permission}-read`}>
                                          Read
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-6 mb-2">
                                      <div className="form-check">
                                        <input 
                                          className="form-check-input" 
                                          type="checkbox" 
                                          id={`${permission}-write`} 
                                          checked={formData.actions.find(a => a.permission === permission)?.actions.includes('write')}
                                          onChange={() => updateActions(permission, 'write')} 
                                        />
                                        <label className="form-check-label" htmlFor={`${permission}-write`}>
                                          Write
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-6 mb-2">
                                      <div className="form-check">
                                        <input 
                                          className="form-check-input" 
                                          type="checkbox" 
                                          id={`${permission}-update`} 
                                          checked={formData.actions.find(a => a.permission === permission)?.actions.includes('update')}
                                          onChange={() => updateActions(permission, 'update')} 
                                        />
                                        <label className="form-check-label" htmlFor={`${permission}-update`}>
                                          Update
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-6 mb-2">
                                      <div className="form-check">
                                        <input 
                                          className="form-check-input" 
                                          type="checkbox" 
                                          id={`${permission}-delete`} 
                                          checked={formData.actions.find(a => a.permission === permission)?.actions.includes('delete')}
                                          onChange={() => updateActions(permission, 'delete')} 
                                        />
                                        <label className="form-check-label" htmlFor={`${permission}-delete`}>
                                          Delete
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                        style={{ minWidth: "120px" }}
                      >
                        Update Role
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showUserModal && (
        <RoleModel 
          onClose={() => setShowUserModal(false)}
          onSelect={(user) => {
            setFormData({...formData, userId: user._id || user.id, selectedUser: user});
            setShowUserModal(false);
          }}
        />
      )}
    </div>
  );
}